var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsecase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 19.5C5.76417 19.5 5.351 19.3298 5.0105 18.9895C4.67017 18.649 4.5 18.2358 4.5 17.75V14.3463C4.5 13.8603 4.67017 13.4471 5.0105 13.1067C5.351 12.7664 5.76417 12.5963 6.25 12.5963C6.73583 12.5963 7.149 12.7664 7.4895 13.1067C7.82983 13.4471 8 13.8603 8 14.3463V17.75C8 18.2358 7.82983 18.649 7.4895 18.9895C7.149 19.3298 6.73583 19.5 6.25 19.5ZM12 19.5C11.5142 19.5 11.101 19.3298 10.7605 18.9895C10.4202 18.649 10.25 18.2358 10.25 17.75V6.25C10.25 5.76417 10.4202 5.351 10.7605 5.0105C11.101 4.67017 11.5142 4.5 12 4.5C12.4858 4.5 12.899 4.67017 13.2395 5.0105C13.5798 5.351 13.75 5.76417 13.75 6.25V17.75C13.75 18.2358 13.5798 18.649 13.2395 18.9895C12.899 19.3298 12.4858 19.5 12 19.5ZM17.75 19.5C17.2642 19.5 16.851 19.3298 16.5105 18.9895C16.1702 18.649 16 18.2358 16 17.75V11.1538C16 10.6679 16.1702 10.2548 16.5105 9.9145C16.851 9.57417 17.2642 9.404 17.75 9.404C18.2358 9.404 18.649 9.57417 18.9895 9.9145C19.3298 10.2548 19.5 10.6679 19.5 11.1538V17.75C19.5 18.2358 19.3298 18.649 18.9895 18.9895C18.649 19.3298 18.2358 19.5 17.75 19.5Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsecase);
export default __webpack_public_path__ + "static/media/Usecase.74185182bac7d266770503aae21841f1.svg";
export { ForwardRef as ReactComponent };